import { useEffect, useState } from 'react';
import { SETTINGS_CHANGED } from '../../settingsEvents';

// The viewer's Reduce motion setting, read once for every face on the page.
let pending = null;

function readSetting() {
  if (!pending) {
    pending = fetch('/auth/settings', { cache: 'no-store', credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((b) => Boolean(b && b.settings && b.settings.reduce_motion))
      .catch(() => false);
  }
  return pending;
}

function osReducesMotion() {
  try {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (e) {
    return false;
  }
}

export function _resetFaceMotion() { pending = null; }

// null until known, so a face starts only once it knows whether to move.
export default function useFaceReduceMotion() {
  const [reduce, setReduce] = useState(() => (osReducesMotion() ? true : null));
  useEffect(() => {
    let alive = true;
    const read = () => readSetting().then((v) => { if (alive) setReduce(v || osReducesMotion()); });
    const changed = () => { pending = null; read(); };
    read();
    window.addEventListener(SETTINGS_CHANGED, changed);
    return () => { alive = false; window.removeEventListener(SETTINGS_CHANGED, changed); };
  }, []);
  return reduce;
}
